/**
 * 通过id获取树节点
 */
const getItemById: (
  tree: { [key: string]: any }[],
  id: string | number,
  idAttr?: string,
  childrenAttr?: string
) => any = (tree, id, idAttr = 'id', childrenAttr = 'children') => {
  if (!Array.isArray(tree)) {
    return null;
  }
  let findItem = tree.find((item) => String(item[idAttr]) === String(id));
  if (findItem) {
    return findItem;
  } else {
    for (let i = 0; i < tree.length; i++) {
      if (Array.isArray(tree[i][childrenAttr])) {
        findItem = getItemById(tree[i][childrenAttr], id, idAttr, childrenAttr);
        if (findItem) {
          return findItem;
        }
      }
    }
  }
};

/**
 * 通过字段获取树节点（like）
 */
const getItemByIdLike: (
  tree: { [key: string]: any }[],
  id: string | number,
  idAttr?: string,
  childrenAttr?: string
) => any = (tree, id, idAttr = 'id', childrenAttr = 'children') => {
  if (!Array.isArray(tree)) {
    return null;
  }
  let findItem = tree.find((item) => String(item[idAttr]).includes(String(id)));
  if (findItem) {
    return findItem;
  } else {
    for (let i = 0; i < tree.length; i++) {
      if (Array.isArray(tree[i][childrenAttr])) {
        findItem = getItemByIdLike(
          tree[i][childrenAttr],
          id,
          idAttr,
          childrenAttr
        );
        if (findItem) {
          return findItem;
        }
      }
    }
  }
};

/**
 * 获取id对应树节点父节点
 */
const getParentItemById: (
  tree: { [key: string]: any }[],
  id: string | number,
  idAttr?: string,
  childrenAttr?: string
) => any = (tree, id, idAttr = 'id', childrenAttr = 'children') => {
  if (!Array.isArray(tree)) {
    return null;
  }
  for (let i = 0; i < tree.length; i++) {
    if (Array.isArray(tree[i][childrenAttr])) {
      let findItem = tree[i][childrenAttr].find(
        (item) => String(item[idAttr]) === String(id)
      );
      if (findItem) {
        return tree[i];
      } else {
        findItem = getParentItemById(
          tree[i][childrenAttr],
          id,
          idAttr,
          childrenAttr
        );
        if (findItem) {
          return findItem;
        }
      }
    }
  }
};

/**
 * 通过level获取树节点
 * @param tree 树节点数据
 * @param minLevel 最小级别
 * @param maxLevel 最大级别
 * @param childrenAttr children属性名
 */
const getTreeByLevel: (
  tree: { [key: string]: any }[],
  minLevel: number,
  maxLevel?: number,
  childrenAttr?: string
) => any = (tree, minLevel = 1, maxLevel, childrenAttr = 'children') => {
  // 获取最小级别数据
  const newTree = JSON.parse(JSON.stringify(tree));
  let resultTree = newTree;
  for (let i = 1; i < minLevel; i++) {
    const tempResultTree = resultTree;
    resultTree = [];
    tempResultTree.forEach((item) => {
      if (Array.isArray(item[childrenAttr])) {
        resultTree = resultTree.concat(item[childrenAttr]);
      }
    });
  }

  // 获取最大级别数据
  if (maxLevel >= minLevel) {
    let tempResultTree = resultTree;
    for (let i = 0; i <= maxLevel - minLevel; i++) {
      if (i === maxLevel - minLevel) {
        tempResultTree.forEach((item) => {
          delete item[childrenAttr];
        });
      } else {
        let tempResultTree1 = [];
        tempResultTree.forEach((item) => {
          if (Array.isArray(item[childrenAttr])) {
            tempResultTree1 = tempResultTree1.concat(item[childrenAttr]);
          }
        });
        tempResultTree = tempResultTree1;
      }
    }
  }

  return resultTree;
};

/**
 * 通过参数获取树节点
 */
const getItemByParams: (
  tree: { [key: string]: any }[],
  attName: string,
  attValue: any,
  childrenAttr?: string
) => any = (tree, attName, attValue, childrenAttr = 'children') => {
  if (!Array.isArray(tree)) {
    return null;
  }
  if (!Array.isArray(attValue)) {
    attValue = [attValue];
  }
  let findItem = null;
  attValue.forEach((itemVal) => {
    const tmpFindItem = getItemById(tree, itemVal, attName, childrenAttr);
    if (tmpFindItem) {
      findItem = tmpFindItem;
    }
  });
  return findItem;
};

/**
 * 通过传入筛选条件，获取被筛选后的树节点
 * @param tree 树数据
 * @param attName 查询name
 * @param attValue 查询值，如果是数组，则取包含
 * @param childrenAttr children属性名
 * @param deepFilter 是否深入查找，即当前节点已有匹配，是否使用条件继续筛选子节点，默认为筛选
 * @returns
 */
const getTreeByParams: (
  tree: { [key: string]: any }[],
  attName: string,
  attValue: any,
  childrenAttr?: string,
  deepFilter?: boolean
) => any = (
  tree,
  attName,
  attValue,
  childrenAttr = 'children',
  deepFilter = true
) => {
  if (!Array.isArray(tree)) {
    return;
  }
  const copyTree = JSON.parse(JSON.stringify(tree));
  if (!Array.isArray(attValue)) {
    attValue = [attValue];
  }
  const newTree = [];
  copyTree.forEach((item) => {
    const findChildItem = getItemByParams(
      item[childrenAttr] || [],
      attName,
      attValue
    );
    if (attValue.includes(item[attName])) {
      newTree.push(item);
      if (!findChildItem && deepFilter) {
        delete item[childrenAttr];
      }
    } else if (findChildItem) {
      newTree.push(item);
    }
    if (findChildItem) {
      item[childrenAttr] = getTreeByParams(
        item[childrenAttr],
        attName,
        attValue,
        childrenAttr,
        deepFilter
      );
    }
  });
  return newTree;
};

/**
 * 通过传入筛选条件，获取被筛选后的树节点(like模式)
 * @param tree 树数据
 * @param attName 查询name
 * @param attValue 查询值，如果是数组，则取包含
 * @param childrenAttr children属性名
 * @param deepFilter 是否深入查找，即当前节点已有匹配，是否使用条件继续筛选子节点，默认为筛选
 * @returns
 */
const getTreeByParamsLike: (
  tree: { [key: string]: any }[],
  attName: string,
  attValue: any,
  childrenAttr?: string,
  deepFilter?: boolean
) => any = (
  tree,
  attName,
  attValue,
  childrenAttr = 'children',
  deepFilter = true
) => {
  if (!Array.isArray(tree)) {
    return;
  }
  const copyTree = JSON.parse(JSON.stringify(tree));
  const newTree = [];
  copyTree.forEach((item) => {
    const findChildItem = getItemByIdLike(
      item[childrenAttr] || [],
      attValue,
      attName,
      childrenAttr
    );
    if (item[attName].includes(attValue)) {
      newTree.push(item);
      if (!findChildItem && deepFilter) {
        delete item[childrenAttr];
      }
    } else if (findChildItem) {
      newTree.push(item);
    }
    if (findChildItem) {
      item[childrenAttr] = getTreeByParamsLike(
        item[childrenAttr],
        attName,
        attValue,
        childrenAttr,
        deepFilter
      );
    }
  });
  return newTree;
};

/**
 * 通过集合及关联字段组装一棵树
 * @param str
 * @returns
 */
const generateTreeByList = (
  list: any[],
  idName = 'id',
  parentIdName = 'parent_id'
) => {
  if (!list) {
    return null;
  }
  const listObj = {};
  const listParentObj: { [key: string]: any[] } = {};
  list.forEach((item) => {
    listObj[item[idName]] = item;
    listParentObj[item[parentIdName]] = listParentObj[item[parentIdName]] || [];
    listParentObj[item[parentIdName]].push(item);
  });
  // 获取根节点，parentId找不到对应Id数据则为根节点
  const rootItems: any[] = [];
  list.forEach((item) => {
    if (!listObj[item[parentIdName]]) {
      rootItems.push(item);
    }
  });
  rootItems.forEach((rootItem) => {
    // 查找节点的子节点
    _generateChildren(rootItem, listParentObj, idName);
  });
  return rootItems;
};

/**
 * 打平树状数据
 * @param tree 树数据
 * @param childrenAttr 子节点属性名称
 * @param result
 * @returns
 */
const planishTree = (tree, childrenAttr = 'children', result = []) => {
  if (!Array.isArray(tree)) {
    return tree;
  }
  tree.forEach((item) => {
    result.push(item);
    planishTree(item[childrenAttr], childrenAttr, result);
  });
  return result;
};

// 通过parentId查找子节点集合
const _generateChildren = (
  parentItem: any,
  parentObj: { [key: string]: any[] },
  idName: string
) => {
  parentItem.children = parentObj[parentItem[idName]] || [];
  if (parentItem.children.length > 0) {
    parentItem.children.forEach((childItem) => {
      _generateChildren(childItem, parentObj, idName);
    });
  }
};
export {
  getItemById,
  getParentItemById,
  getTreeByLevel,
  getTreeByParams,
  generateTreeByList,
  getTreeByParamsLike,
  planishTree,
};
